import { render, staticRenderFns } from "./SectionNews.vue?vue&type=template&id=4c7b5320&scoped=true"
import script from "./SectionNews.vue?vue&type=script&lang=js"
export * from "./SectionNews.vue?vue&type=script&lang=js"
import style0 from "./SectionNews.vue?vue&type=style&index=0&id=4c7b5320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7b5320",
  null
  
)

export default component.exports